import { ref, computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useCustomCore } from '@rebuild/materials/shared/custom/context';

export const isPdf = url => typeof url === 'string' && url.toLowerCase().endsWith('.pdf');

export function useCustomPure(props) {
	const { getRealModuleId, findModule } = useCustomCore();
	const getModuleId = computed(() => getRealModuleId(props.moduleId));

	const { custom } = useModuleData();
	const moduleList = ref([]);
	const isEmpty = computed(() => !moduleList.value.length || custom.empty);

	const headerTitle = ref('');
	const { viewModule } = useModuleNavigation();
	const handlePreview = item => viewModule('custom', item, headerTitle.value);

	const initBase = async loadFn => {
		const found = findModule(getModuleId.value);
		if (found?.name) headerTitle.value = found.name;
		if (!getModuleId.value) return;
		await loadFn();
	};

	return { getModuleId, custom, moduleList, isEmpty, handlePreview, initBase };
}
